import Header from "../components/sections/Header";
import Hero from "../components/sections/Hero";
import ClientLogos from "../components/sections/ClientLogos";
import Services from "../components/sections/Services";
import HowItWorks from "../components/sections/HowItWorks";
import WhyChooseUs from "../components/sections/WhyChooseUs";
import Mission from "../components/sections/Mission";
import CaseStudies from "../components/sections/CaseStudies";
import Team from "../components/sections/Team";
import FAQ from "../components/sections/FAQ";
import ContactForm from "../components/sections/ContactForm";
import Footer from "../components/sections/Footer";

export default function LandingPage() {
  return (
    <div data-testid="landing-page" className="min-h-screen bg-dark">
      <Header />
      <main>
        <Hero />
        <ClientLogos />
        <Services />
        <HowItWorks />
        <WhyChooseUs />
        <Mission />
        <CaseStudies />
        <Team />
        <FAQ />
        <ContactForm />
      </main>
      <Footer />
    </div>
  );
}
